import { HealthReportFile } from '@/modules/reports/health-reports/domain/health-report-file';
import moment from 'moment/moment';

export class HealthReport {
    public readonly name: string;
    public readonly date: string;
    public readonly customer: string;
    public readonly quarter: number;
    public readonly year: number;

    constructor(file: HealthReportFile) {
        const n = file.name.split('-');
        this.year = parseInt(n[0]);
        this.date = `${n[0]}-${n[1]}`;
        this.name = file.name;
        this.customer = n[3].split('.')[0];
        this.quarter = moment(`${this.date}-03`).quarter();
    }

    get quarterName(): string {
        switch (this.quarter) {
            case 1:
                return 'Primer trimestre de ' + this.year;
            case 2:
                return 'Segundo trimestre de ' + this.year;
            case 3:
                return 'Tercer trimestre de ' + this.year;
            case 4:
                return 'Cuarto trimestre de ' + this.year;
        }
        return 'Trimestre indefinido ' + this.year;
    }

    get ord(): number {
        return this.year + this.quarter / 4;
    }
}
